export const TYPE_DELIVERY = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup'
}
export const TYPE_PAYMENT = {
  CARD_ONLINE: 'card_online',
  CASH: 'cash',
  CARD_IN_PLACE: 'card_in_place',
  SBERBANK: 'sberbank',
  PAYMENT_LINK: 'payment_link',
  COMBO: 'combo'
}
export const TYPE_DISCOUNT = {
  WITHOUT: 'without',
  PERCENT: 'percent',
  SUM_RUB: 'sum_rub',
  POINTS: 'points',
  PROMO: 'promo',
  PACKAGE: 'package',
  BONUSES_DD: 'bonusdd',
  PROMO_11: 'aktsia_1+1',
  CARD10: 'karta10',
  CARD15: 'karta15',
  CARD20: 'karta20',
  CARD30: 'karta30',
  BIRTHDAY20: 'birthday20',
  BIRTHDAY25: 'birthday25',
  TAKEAWAY: 'takeaway10'

}
export const STATUS_ORDER = {
  NEW: 'new',
  APPROVED: 'approved',
  WAITING: 'waiting',
  COOKING: 'cooking',
  COOKED: 'cooked',
  CANCELED: 'canceled',
  COLLECTED: 'collected',
  SENDED: 'in_delivery',
  PASSED: 'passed',
  END: 'ended'
}
export const STATUS_WORKER = {
  WAITING: 'waiting',
  DELIVERY: 'delivery',
  DELIVERED: 'delivered'
}
export const STATUS_DELIVERY = {
  NEW: 'waiting',
  CHOSEN_COURIER: 'courier',
  IN_DELIVERY: 'delivery',
  END: 'ended'
}
export const STATUS_TASK_WORKSHOP = {
  COMMON: {
    CANCELED: 'canceled',
    CANCELED_CONFIRM: 'canceled'
  },
  COLD: {
    WAITING: 'waiting',
    KNURLING: 'knurling',
    KNURLED: 'knurled',
    CUTTING: 'cutting',
    COOKED: 'cooked'
  },
  HOT: {
    WAITING: 'waiting',
    COOKING: 'cooking',
    COOKED: 'cooked'
  },
  PIZZA: {
    WAITING: 'waiting',
    ROLLING: 'rolling',
    ROLLED: 'rolled',
    FILLING: 'filling',
    BAKING: 'baking',
    COOKED: 'cooked',
    DELETED: 'deleted'
  }
}
export const UPDATE_STAGE_TASK = {
  NEXT: 'next',
  WAITING: 'waiting',
  FINISH: 'finish'
}
export const TYPE_LOGIC_DISCOUNT = {
  SUM: 'sum',
  PERCENT: 'percent',
  PICKUP_PERCENT: 'pickup_percent',
  PROMOCODE: 'promocode'
}


// WEBPACK FOOTER //
// ./src/constants/keywords.js